<template>
  <div id="bar">
    <h3 class="p-3 text-white">订单数量统计 </h3>
    <div class="h4 pb-2  d-flex align-items-center justify-content-end pr-5" >
      <p v-for="item in selectOpt" :key="item.id">
        <span class="pr-3" :class="item.id === selectItem.id ? 'text-white': 'text-link'" @click="selectOperate(item)">{{item.name}}</span>
      </p>
    </div>
    <div id="sta_bar"></div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts');
  // 引入柱状图
  require('echarts/lib/chart/bar');
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip');
  require('echarts/lib/component/legendScroll');

  export default {
    name: 'StatisticalData',
    data() {
      return {
        selectOpt:[
          {name:'酒店',id:3},
          {name:'民宿',id:5},
          {name:'景区',id:6},
        ],
        selectItem:'',                         //选中的项目
      }
    },
    computed: {
      ...mapState(['StoreChartLists']),
      orderList() {
        let title = [];
        let item = this.StoreChartLists.order;
        for (let i in item) {
          title.push({
            title: i,
            pay: item[i].payOrderNum,
            send: item[i].sendOrderNum,
            transaction: item[i].transactionOrderNum,
            type: 'bar'
          });
        }
        return title;
      },
      dataArr() {
        return [
          {name: '支付订单数',type: 'bar', stack: 'one', data: this.orderList.map(v => v.pay)},
          {name: '成交订单数',type: 'bar',stack: 'two',data: this.orderList.map(v => v.transaction)},
          {name: '发布订单数',type: 'bar',stack: 'three',data: this.orderList.map(v => v.send)}
        ]
      }
    },
    watch: {
      'orderList': 'initEchart'
    },
    methods: {
      initEchart() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init($('#sta_bar').get(0));
        let option = {
          legend: {
            textStyle:{
              fontSiz:18,
              color:'white'
            },
            data: this.dataArr.map(v => v.name),
            align: 'left',
            left: '35%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'category',
            data: this.orderList.map(v => v.title),
            axisLabel: {
              rotate: 45,
              color:'#919191',
              interval:0
            },
            axisLine:{
              lineStyle:{
                color:'#919191'
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color:'#919191'
            },
            axisLine:{
              lineStyle:{
                color:'#919191'
              }
            }
          },
          series: this.dataArr,
        };
        // 绘制图表
        myChart.setOption(option);
      },
      selectOperate(item) {
        this.$emit('changeTheme',item.id);
        this.selectItem = item;
      }
    }
  }
</script>
<style scoped lang="scss">
  #bar {
    width: 100%;
    background-color: #20283e;
  }

  #sta_bar {
    width: 900px;
    height: 500px;
    margin: 0 auto;
  }
</style>
